import React, { type FC } from 'react'
import { Box, type SxProps, type Theme } from '@mui/material'

const DEFAULT_DOT_SIZE = 6

type StatusDotTone = 'success' | 'warning' | 'error' | 'grey'

type Props = Readonly<{
    /** `className` must be forwarded: MUI's Chip injects its icon classes through it, which the chip variants style */
    className?: string
    size?: number
    /** Without a tone the dot takes the surrounding `currentColor`, so a status chip variant decides it through the chip's icon slot */
    tone?: StatusDotTone
}>

const dotStyle = (size: number, tone: StatusDotTone | undefined): SxProps<Theme> => ({
    flex: 'none',
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: tone ? `${tone}.500` : 'currentColor',
})

export const StatusDot: FC<Props> = ({ className, size = DEFAULT_DOT_SIZE, tone }) => <Box component="span" className={className} sx={dotStyle(size, tone)} />
